/* 
  
  MF Simulator: react-i18next configuration file
  
*/


import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    fallbackLng: "en",
    lowerCaseLng: true,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          mlr: {
            rev_num: "2026PP06033"
          },
          actions: {
            scroll_to_play: "Scroll to play",
            scroll_to_continue: "Scroll to the bottom to continue",
            play: "Play",
            important_info: "Important Info",
            cta: "Learn more"
          },
          main: {
            h1: "ACUVUE<sup>®</sup> Multifocal provides crisp, clear, reliable vision at all distances, enabling you to continue to see distance, intermediate and near tasks.",
            h2: "Explore everyday moments with and without ACUVUE<sup>®</sup> Multifocal contact lenses.",
            orientation: "For the best experience, please rotate your phone to landscape mode.",
            button: "See the difference",
            disclaimer1: "For illustration purposes only.",
            disclaimer2: "Individual results may vary. This is not intended to diagnose presbyopia or any other eye condition, please see your eye care professional for any official diagnosis and treatment options.",
          },
          orientation: {
            h1: "Please rotate your phone to landscape.",
            unlock: "Ensure screen rotation is unlocked"
          },
          simulator: {
            modal: {
              title: "What is Multifocal Contact Lenses?",
              content: "ACUVUE<sup>®</sup> Multifocal contact lenses (MFCLs) feature advanced optical designs that allow for seamless transitions between different visual distances, giving you the freedom of clear vision near, far and in between."
            },
            controls: {
              ask_mfcl: "Ask for ACUVUE<sup>®</sup> MFCLs"
            },
            information: {
              presbyopia_info: "Click to show presbyopia information",
              mfcl_info: "Click to show multifocal contact lens information"
            },
            videos: {
              dining: {
                short_title: "Dining",
              },
              driving: {
                short_title: "Driving",

              },
              shopping: {
                short_title: "Shopping",
              }
            },
            dialog: {
              common: {
                title: "Experience seamless vision with ACUVUE<sup>®</sup> Multifocal contact lenses",
                content1: "Compare the visual clarity of objects in the videos as they appear at different distances.",
                content2: "<strong>For illustrative purposes only. Individual results may vary.</strong>",
                content3: "This is not intended to diagnose presbyopia or any other eye condition, please see your eye care professional for any official diagnosis and treatment options."
              },
              initial: {
                content1: "<strong>Important Information for Contact Lens Wearers</strong>",
                content2: "ACUVUE<sup>®</sup> Contact Lenses are available by prescription only for vision correction. An eye care professional will determine whether contact lenses are right for you. Although rare, serious eye problems can develop while wearing contact lenses. To help avoid these problems, follow the wear and replacement schedule and the lens care instructions provided by your eye doctor. Do not wear contact lenses if you have an eye infection, or experience eye discomfort, excessive tearing, vision changes, redness or other eye problems. If one of these conditions occurs, remove the lens and contact your eye doctor immediately. For more information on proper wear, care and safety, talk to your eye care professional and ask for a Patient Instruction Guide, call 1-800-843-2020, or download the ",
                guide_text_us: "US Patient Instruction Guide",
                guide_link_us: "https://www.acuvue.com/en-us/patient-instruction-guides/",
                guide_text_canada: "Canada Patient Instruction Guide",
                guide_link_canada: "https://www.acuvue.com/en-ca/patient-instruction-guides/"
              },
              cta: {
                content: "Ready to ask for ACUVUE<sup>®</sup> Multifocal Contact Lenses?"
              }
            },
          },
          carousel: {
            titles: {
              shopping: "Shopping",
              driving: "Driving",
              dining: "Dining",
              what: "What is Presbyopia",
              why: "Why choose ACUVUE<sup>®</sup>"
            }
          },
        }
      },
      zh: {
        translation: {
          mlr: {
            rev_num: "HKM20250930_001"
          },
          actions: {
            scroll_to_play: "向下滾動開始",
            scroll_to_continue: "向下滾動開始",
            play: "開始",
            important_info: "重要資訊",
            cta: "了解更多"
          },
          main: {
            h1: "立刻「睇 」驗ACUVUE<sup>®</sup>多焦點(老花)隱形眼鏡，清楚看見遠、中、近的景物",
            h2: "探索生活中的日常配戴時刻",
            orientation: "為了獲得最佳體驗，請將手機轉為橫屏模式。",
            button: "立即探索",
            disclaimer1: "僅供示意用途。",
            disclaimer2: "個人結果可能會有所不同。此內容並非用於診斷老花眼或其他眼睛情況，請諮詢您的眼科專業人士以獲得正式診斷和治療方案。",
          },
          orientation: {
            h1: "請將手機轉為橫屏。",
            unlock: "確保已解鎖螢幕旋轉。"
          },
          simulator: {
            modal: {
              title: "什麼是多焦點隱形眼鏡？",
              content: "ACUVUE<sup>®</sup>多焦點(老花)隱形眼鏡具有先進的光學設計，能在不同視覺距離之間實現無縫過渡，讓您自由享受清晰的遠、中、近距離視覺。"
            },
            controls: {
              ask_mfcl: "了解ACUVUE®多焦點隱形眼鏡"
            },
            information: {
              presbyopia_info: "了解更多老花資訊",
              mfcl_info: "了解更多ACUVUE®多焦點隱形眼鏡"
            },
            videos: {
              dining: {
                short_title: "用餐時",
              },
              driving: {
                short_title: "駕駛時",

              },
              shopping: {
                short_title: "購物時",
              }
            },
            dialog: {
              common: {
                title: "體驗ACUVUE<sup>®</sup>老花隱形眼鏡帶來的無縫視覺",
                content1: "比較影片中物體在不同距離的視覺清晰度。",
                content2: "<strong>僅供示意用途。個人結果可能會有所不同。</strong>",
                content3: "此內容並非用於診斷老花眼或其他眼睛情況，請諮詢您的眼科專業專業人士以獲得正式診斷和治療方案。"
              },
              initial: {
                content1: "<strong>隱形眼鏡配戴者的重要提示：</strong>",
                content2: "ACUVUE<sup>®</sup>隱形眼鏡主要用於矯正視力(美瞳隱形眼鏡同時提供平光鏡片)，需由專業眼科視光師確定你是否適合驗配隱形眼鏡，並提供驗光處方購買。即使情況十分罕見，配戴隱形眼鏡過程中仍有機會出現眼部健康問題。因此，正確配戴及護理隱形眼鏡是非常重要。若你察覺到眼部受感染、眼睛不適、流眼水、視力改變、眼睛發紅或其他狀況，請不要繼續配戴隱形眼鏡，並立即諮詢專業眼科視光師或專業眼科醫生。了解更多有關正確配戴隱形眼鏡、有關安全性及眼睛護理的資訊，請諮詢專業眼科視光師或下載配戴者使用指南。你亦可於辦公時間(星期一至五早上9時至下午5時半，公眾假期除外) 致電852-2588-1100聯絡我們。",
                guide_text: "配戴者使用指南",
                guide_link: "https://www.acuvue.com/zh-hk/patient-instruction-guides/"
              },
              cta: {
                content: "準備好驗配ACUVUE<sup>®</sup>老花隱形眼鏡了嗎？"
              }
            },
          },
          carousel: {
            titles: {
              shopping: "購物時",
              driving: "駕駛時",
              dining: "用餐時",
              what: "什麼是老花？",
              why: "為什麼選擇ACUVUE<sup>®</sup>"
            }
          },
        }
      },
      "fr-ca": {
        translation: {
          mlr: {
            rev_num: "2026PP06033"
          },
          actions: {
            scroll_to_play: "Faites défiler vers le bas pour continuer",
            scroll_to_continue: "Faites défiler vers le bas pour continuer",
            play: "Lancer",
            important_info: "Informations importantes",
            cta: "Pour en savoir plus"
          },
          main: {
            h1: "Les verres multifocaux ACUVUE<sup>MD</sup> offrent une vision claire, nette et fiable à toutes les distances, vous permettant de continuer à voir de près, de loin et à toutes les distances intermédiaires.",
            h2: "Découvrez les moments de la vie quotidienne avec et sans les verres de contact multifocaux ACUVUE<sup>MD</sup>.",
            orientation: "Pour profiter pleinement de cette expérience, veuillez mettre votre téléphone en mode paysage.",
            button: "Voir la différence",
            disclaimer1: "Aux fins d'illustration seulement.",
            disclaimer2: "Les résultats peuvent varier d'une personne à l'autre. Ce test n'est pas destiné à diagnostiquer la presbytie ou toute autre affection oculaire; veuillez consulter votre professionnel des soins de la vue pour obtenir un diagnostic officiel et connaître les options de traitement.",
          },
          orientation: {
            h1: "Veuillez mettre votre téléphone en mode paysage.",
            unlock: "Assurez-vous que la rotation de l'écran est activée."
          },
          simulator: {
            modal: {
              title: "Qu'est-ce qu'une lentille cornéenne multifocale?",
              content: "Les verres de contact multifocaux ACUVUE<sup>MD</sup> intègrent des conceptions optiques avancées qui permettent des transitions fluides entre les différentes distances visuelles pour vous offrir la liberté d'une vision claire de près, de loin et à distance intermédiaire."
            },
            controls: {
              ask_mfcl: "Demandez les verres de contact multifocaux ACUVUE<sup>MD</sup>"
            },
            information: {
              presbyopia_info: "Cliquer pour voir les informations sur la presbytie",
              mfcl_info: "Cliquer pour voir les informations sur les verres de contact multifocaux"
            },
            videos: {
              dining: {
                short_title: "Aller au restaurant",
              },
              driving: {
                short_title: "Conduite",

              },
              shopping: {
                short_title: "Magasinage",
              }
            },
            dialog: {
              common: {
                title: "Bénéficiez d'une vision fluide avec les verres de contact multifocaux ACUVUE<sup>MD</sup>.",
                content1: "Comparez la netteté visuelle des objets dans les vidéos selon leur distance.",
                content2: "<strong>Aux fins d'illustration seulement. Les résultats peuvent varier d'une personne à l'autre.</strong>",
                content3: "Ces informations ne visent pas à diagnostiquer la presbytie ni aucune autre affection oculaire. Veuillez consulter votre professionnel des soins de la vue pour obtenir un diagnostic officiel et connaître les options de traitement."
              },
              initial: {
                content1: "<strong>Informations importantes pour les porteurs de verres de contact</strong>",
                content2: "Les verres de contact ACUVUE<sup>MD</sup> sont disponibles sur ordonnance seulement pour corriger la vue. Un professionnel des soins de la vue peut déterminer si ces verres de contact vous conviennent. Le port de verres de contact peut entraîner, bien que rarement, de graves problèmes de la vue. Pour éviter ces problèmes, il faut respecter les programmes de port et de remplacement des verres ainsi que les instructions d’entretien fournis par le professionnel des soins de la vue. Ne pas porter de verres de contact en cas d’infection ou de gêne oculaires, de larmoiement excessif, de changements de la vue, de rougeurs ou d’autres problèmes oculaires. Si l’une ou l’autre de ces conditions se manifeste, retirer les verres de contact et communiquer immédiatement avec un professionnel des soins de la vue. Pour obtenir plus d’information sur le port, l’entretien et la sécurité des verres de contact, parler à un professionnel des soins de la vue et demander le guide d’instructions à l’intention des patients, composer le 1 800 667-5099 ou télécharger le ",
                guide_text: "Guide d'instructions à l'intention des patients (Canada)",
                guide_link: "https://www.acuvue.com/fr-ca/patient-instruction-guides/"
              },
              cta: {
                content: "Êtes-vous prêt à demander les verres de contact multifocaux ACUVUE<sup>MD</sup>?"
              }
            },
          },
          carousel: {
            titles: {
              shopping: "Magasinage",
              driving: "Conduite",
              dining: "Aller au restaurant",
              what: "Qu'est-ce que la presbytie?",
              why: "Pourquoi choisir ACUVUE<sup>MD</sup>"
            }
          },
        }
      },
      "ja-jp": {
        translation: {
          mlr: {
            rev_num: "2026PP11252"
          },
          actions: {
            scroll_to_play: "続行するには下までスクロールしてください",
            scroll_to_continue: "続行するには下までスクロールしてください",
            play: "始める",
            important_info: "重要",
            cta: "詳細はこちら"
          },
          main: {
            h1: "アキュビュー<sup>®</sup> 遠近両用コンタクトレンズで、遠方、中間、近方のすべての距離において、クリアで安定した見え方を。",
            h2: "遠近両用コンタクトレンズを装用した場合と、装用していない場合の日常生活のさまざまなシーンを体験してみましょう",
            orientation: "スマートフォンを横向き（横画面）にしてご覧ください。",
            button: "見え方の違いを体験",
            disclaimer1: "本コンテンツはイメージです。",
            disclaimer2: "実際の見え方には個人差があります。本コンテンツは、老眼やその他の眼の状態を診断する目的のものではありません。正式な診断や治療については、眼科医にご相談ください。",
          },
          orientation: {
            h1: "スマートフォンを横向き（横画面）にしてご覧ください。",
            unlock: "画面の自動回転がオンになっていることをご確認ください。"
          },
          simulator: {
            modal: {
              title: "遠近両用コンタクトレンズとは？",
              content: "遠近両用コンタクトレンズは、遠くから近くまで見ることができるコンタクトレンズです。\nアキュビュー<sup>®</sup> 遠近両用コンタクトレンズは、瞳孔の大きさの違いに最適化したアキュビュー® 独自のレンズ設計により、遠くから近くまでのすべての距離で、快適でクリアな見え方を目指しています。"
            },
            controls: {
              ask_mfcl: "アキュビュー<sup>®</sup> 遠近両用コンタクトレンズを相談できる眼科を探す"
            },
            information: {
              presbyopia_info: "老眼についてクリックして表示",
              mfcl_info: "遠近両用コンタクトレンズについてクリックして表示"
            },
            videos: {
              dining: {
                short_title: "食事",
              },
              driving: {
                short_title: "運転",

              },
              shopping: {
                short_title: "買い物",
              }
            },
            dialog: {
              common: {
                title: "アキュビュー<sup>®</sup> 遠近両用コンタクトレンズによる、遠くから近くまでの自然な見え方を体験",
                content1: "動画の中に出てくるものが、さまざまな距離で、どのように見えるかを比べてみましょう。",
                content2: "<strong>本コンテンツはイメージです。実際の見え方には個人差があります。</strong>",
                content3: "本コンテンツは、老眼やその他の眼の状態を診断する目的のものではありません。正式な診断や治療については、眼科にご相談ください。"
              },
              initial: {
                content1: "<strong>コンタクトレンズ使用に関する重要な注意事項</strong>",
                content2: "アキュビュー<sup>®</sup> コンタクトレンズは、視力補正を目的としたコンタクトレンズであり、必ず事前に眼科医にご相談の上、検査・処方を受けてお求めください。稀ではありますが、コンタクトレンズの装用中に重篤な眼障害が発生する可能性があります。これらのリスクを避けるため、眼科医から指示された装用方法、交換スケジュール、レンズケアの指示を必ず守ってください。目の感染、目の不快感、過度の涙、視力の変化、充血、その他の異常を感じた場合は、コンタクトレンズの使用を中止してください。これらの症状が現れた場合は、直ちにレンズを外し、眼科医に相談してください。正しい装用方法、ケア方法、安全性については、眼科医にご相談いただくか、アキュビュー<sup>®</sup> ユーザーガイドまたは添付文書をご確認ください。",
                guide_text: "アキュビュー® ユーザーガイド",
                guide_link: "https://www.acuvue.com/ja-jp/new-wearer/new-wearer-guide/"
              },
              cta: {
                content: "アキュビュー<sup>®</sup> 遠近両用コンタクトレンズについて詳しく見る"
              }
            },
          },
          carousel: {
            titles: {
              shopping: "買い物",
              driving: "運転",
              dining: "食事",
              what: "老眼とは？",
              why: "アキュビュー<sup>®</sup> が選ばれる理由"
            }
          },
        }
      },
    }
  });

export default i18n;
